﻿import $ from "jquery";

window.$ = window.jQuery = $;

setTimeout(function () {
    $("body").removeClass("preload");
}, 500);